<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>摄像机详情</span>
          <div class="toolbar-items">

          </div>
        </div>
      </template>
    </el-page-header>

    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="摄像机编码" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.code"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="摄像机名称" class="detail-form-item">
                  <el-input size="medium" v-model="entity.name"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="类型" class="detail-form-item" prop="type">
                  <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                    <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="状态" class="detail-form-item">
                  <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                    <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="IP地址" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.ip"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="端口" class="detail-form-item">
                  <el-input size="medium" v-model="entity.port"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="通道号" class="detail-form-item">
                  <el-input size="medium" v-model="entity.channel"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="SDK版本" class="detail-form-item">
                  <el-input size="medium" v-model="entity.version"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="用户名" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.user"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="密码" class="detail-form-item">
                  <el-input size="medium" v-model="entity.password"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="连接时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.connectTime"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="重连次数" class="detail-form-item">
                  <el-input size="medium" v-model="entity.maxLoginTime"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="流媒体编号" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.videoSourceNo"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="流媒体地址" class="detail-form-item">
                  <el-input size="medium" v-model="entity.videoSourceUrl"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="延时播放时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.videoAddSeconds"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="备注" class="detail-form-item">
                  <el-input type="textarea" rows="5" v-model="entity.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.creator" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>

</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext} from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import { createCameraContext } from "@/script/apps/device/config/DeviceConfig";
import { Camera } from "@/script/apps/device/entity/DeviceEntity";

@Options({})
export default class CameraDetail extends BaseDetail {
  public initData(): ServiceContext {
    return createCameraContext();
  }

  public newEntity() {
    const entity: Camera = {};
    return entity;
  }
}
</script>

<style lang="scss">
</style>
